module.exports = __webpack_public_path__ + "img/leavesBg.d9a80949.png";